<div class="d-block mt-2 mb-1">
    <div *ngFor="let option of props.options | formlySelectOptions : field | async; let i = index"
        class="form-check"
        [class.form-check-inline]="props.formCheck === 'inline'">
        <input type="radio"
            [id]="id + '_' + i"
            class="form-check-input"
            [name]="field.name || id"
            [class.is-invalid]="showError"
            [attr.value]="option.value"
            [value]="option.value"
            [formControl]="option.disabled ? disabledControl : formControl"
            [formlyAttributes]="field" />
        <label class="form-check-label"
            [for]="id + '_' + i">
            {{ option.label }}
        </label>
    </div>
</div>